<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item label="商品名称">
                <a-input v-model="queryParam.goodsName" placeholder="请输入商品名称" allow-clear />
              </a-form-item>
            </a-col>
<!--            <a-col :md="6" :sm="24">-->
<!--              <a-form-item label="商品编码">-->
<!--                <a-input v-model="queryParam.goodsCode" placeholder="请输入商品编码" allow-clear />-->
<!--              </a-form-item>-->
<!--            </a-col>-->
            <a-col :md="6" :sm="24">
              <a-form-item label="SKU名称">
                <a-input v-model="queryParam.skuName" placeholder="请输入SKU名称" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="业务类型">
                <a-select v-model="queryParam.bizType" placeholder="请选择" allow-clear>
                  <a-select-option value="">全部</a-select-option>
                  <a-select-option value="PURCHASE">要货</a-select-option>
                  <a-select-option value="USER_RETURN">用户退货</a-select-option>
                  <a-select-option value="SELL">销售</a-select-option>
                  <a-select-option value="PROCUREMENT">采购</a-select-option>
                  <a-select-option value="TRANSFER">调拨</a-select-option>
                  <a-select-option value="LOSS">报损</a-select-option>
                  <a-select-option value="CHECK">盘点</a-select-option>
                  <a-select-option value="SALES">销售</a-select-option>
                  <a-select-option value="RETURN">退货</a-select-option>
                  <a-select-option value="CGRETURN">采购退货</a-select-option>
                  <a-select-option value="SECKILL">设置秒杀库存</a-select-option>
                  <a-select-option value="SECKILL_SELL">秒杀销售</a-select-option>
                  <a-select-option value="SECKILL_SELL_RETURN">秒杀活动退货</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="业务单号">
                <a-input v-model="queryParam.bizNo" placeholder="请输入业务单号" allow-clear />
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="48">
<!--            <a-col :md="6" :sm="24">-->
<!--              <a-form-item label="组织ID">-->
<!--                <a-input v-model="queryParam.orgId" placeholder="请输入组织ID" allow-clear />-->
<!--              </a-form-item>-->
<!--            </a-col>-->
            <a-col :md="6" :sm="24">
              <a-form-item label="组织类型">
                <a-select v-model="queryParam.orgType" placeholder="请选择" allow-clear>
                  <a-select-option value="">全部</a-select-option>
                  <a-select-option :value="1">平台</a-select-option>
                  <a-select-option :value="2">商家</a-select-option>
                  <a-select-option :value="3">门店</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="门店名称">
                <a-input v-model="queryParam.orgName" placeholder="请输入门店名称" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="创建时间">
                <a-range-picker
                  v-model="dateRange"
                  @change="handleDateRangeChange"
                  style="width: 100%"
                />
              </a-form-item>
            </a-col>
            <a-col :md="4" :sm="24">
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="handleQuery">
                  <a-icon type="search" />查询
                </a-button>
                <a-button style="margin-left: 8px" @click="resetQuery">
                  <a-icon type="redo" />重置
                </a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>

      <!-- 数据表格 -->
      <a-table
        :columns="columns"
        :dataSource="dataSource"
        :pagination="pagination"
        :loading="loading"
        rowKey="id"
        @change="handleTableChange"
      >
        <span slot="goodsInfo" slot-scope="text, record">
          <div class="goods-info">
            <a-avatar
              shape="square"
              :size="40"
              :src="record.goodsPicture"
              icon="picture"
            />
            <div class="goods-detail">
              <div class="goods-name">{{ record.goodsName }}</div>
              <div class="goods-code">{{ record.goodsCode }}</div>
            </div>
          </div>
        </span>

        <span slot="skuInfo" slot-scope="text, record">
          <div>
            <div>{{ record.skuName }}</div>
            <div class="text-gray">{{ record.skuCode }}</div>
          </div>
        </span>

        <span slot="orgInfo" slot-scope="text, record">
          <div>
            <div>{{ record.orgName }}</div>
            <div class="text-gray">{{ orgTypeMap[record.orgType] }}</div>
          </div>
        </span>

        <span slot="stockChange" slot-scope="text, record">
          <a-tag :color="record.stockChange > 0 ? 'green' : 'red'">
            {{ record.stockChange > 0 ? '+' : '' }}{{ record.stockChange }}
          </a-tag>
        </span>

        <span slot="stockInfo" slot-scope="text, record">
          <div>
            <div>变动前: {{ record.beforeStock }}</div>
            <div>变动后: {{ record.afterStock }}</div>
          </div>
        </span>

        <span slot="bizType" slot-scope="text">
          <a-tag :color="getBizTypeColor(text)">{{ getBizTypeName(text) }}</a-tag>
        </span>

        <span slot="stockType" slot-scope="text">
          <a-tag color="blue">{{ text === 1 ? '可用库存' : '锁定库存' }}</a-tag>
        </span>

        <span slot="createTime" slot-scope="text">
          {{ text }}
        </span>
      </a-table>
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { inventoryLogList } from '@/api/retail/inventory'
import moment from 'moment'

export default {
  name: 'InventoryLog',
  data () {
    return {
      // 查询参数
      queryParam: {
        goodsName: '',
        goodsCode: '',
        skuName: '',
        bizType: '',
        bizNo: '',
        orgId: '',
        orgType: '',
        orgName: '',
        startTime: '',
        endTime: ''
      },
      dateRange: [],
      // 表格数据
      dataSource: [],
      loading: false,
      // 分页
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        showTotal: total => `共 ${total} 条`
      },
      // 表格列
      columns: [
        {
          title: '商品信息',
          dataIndex: 'goodsInfo',
          key: 'goodsInfo',
          width: 200,
          scopedSlots: { customRender: 'goodsInfo' }
        },
        {
          title: 'SKU信息',
          dataIndex: 'skuInfo',
          key: 'skuInfo',
          width: 150,
          scopedSlots: { customRender: 'skuInfo' }
        },
        {
          title: '组织信息',
          dataIndex: 'orgInfo',
          key: 'orgInfo',
          width: 150,
          scopedSlots: { customRender: 'orgInfo' }
        },
        {
          title: '变动类型',
          dataIndex: 'changeTypeDesc',
          key: 'changeTypeDesc',
          width: 80,
          align: 'center'
        },
        {
          title: '变动量',
          dataIndex: 'stockChange',
          key: 'stockChange',
          width: 80,
          align: 'center',
          scopedSlots: { customRender: 'stockChange' }
        },
        {
          title: '库存变化',
          key: 'stockInfo',
          width: 120,
          scopedSlots: { customRender: 'stockInfo' }
        },
        {
          title: '库存类型',
          dataIndex: 'stockType',
          key: 'stockType',
          width: 100,
          align: 'center',
          scopedSlots: { customRender: 'stockType' }
        },
        {
          title: '业务类型',
          dataIndex: 'bizType',
          key: 'bizType',
          width: 100,
          align: 'center',
          scopedSlots: { customRender: 'bizType' }
        },
        {
          title: '业务单号',
          dataIndex: 'bizNo',
          key: 'bizNo',
          width: 150
        },
        {
          title: '操作人',
          dataIndex: 'creatorName',
          key: 'creatorName',
          width: 100
        },
        {
          title: '要货门店',
          dataIndex: 'storeName',
          key: 'storeName',
          width: 80,
          align: 'center'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          key: 'createTime',
          width: 160,
          scopedSlots: { customRender: 'createTime' }
        }
      ],
      // 组织类型映射
      orgTypeMap: {
        1: '平台仓库',
        2: '商家',
        3: '门店'
      }
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    /**
     * 加载数据
     */
    loadData () {
      this.loading = true
      const params = {
        ...this.queryParam,
        current: this.pagination.current,
        size: this.pagination.pageSize
      }

      inventoryLogList(params).then(res => {
        this.dataSource = res.data.records || []
        this.pagination.total = res.data.total || 0
      }).finally(() => {
        this.loading = false
      })
    },

    /**
     * 查询
     */
    handleQuery () {
      this.pagination.current = 1
      this.loadData()
    },

    /**
     * 重置
     */
    resetQuery () {
      this.queryParam = {
        goodsName: '',
        goodsCode: '',
        skuName: '',
        bizType: '',
        bizNo: '',
        orgId: '',
        orgType: '',
        orgName: '',
        startTime: '',
        endTime: ''
      }
      this.dateRange = []
      this.pagination.current = 1
      this.loadData()
    },

    /**
     * 日期范围变化
     */
    handleDateRangeChange (dates, dateStrings) {
      if (dates && dates.length === 2) {
        this.queryParam.startTime = dateStrings[0]
        this.queryParam.endTime = dateStrings[1]
      } else {
        this.queryParam.startTime = ''
        this.queryParam.endTime = ''
      }
    },

    /**
     * 表格变化
     */
    handleTableChange (pagination) {
      this.pagination.current = pagination.current
      this.pagination.pageSize = pagination.pageSize
      this.loadData()
    },

    /**
     * 获取业务类型名称
     */
    getBizTypeName (bizType) {
      const map = {
        'PURCHASE': '要货',
        'USER_RETURN': '用户退货',
        'SELL': '销售',
        'PROCUREMENT': '采购',
        'TRANSFER': '调拨',
        'TRANSFER_CANCEL': '调拨取消',
        'LOSS': '报损',
        'CHECK': '盘点',
        'SALES': '销售',
        'RETURN': '退货',
        'CGRETURN': '采购退货',
        'SECKILL_SELL': '秒杀销售',
        'SECKILL_SELL_RETURN': '秒杀活动退货',
        'SECKILL': '设置秒杀库存'
      }
      return map[bizType] || bizType
    },

    /**
     * 获取业务类型颜色
     */
    getBizTypeColor (bizType) {
      const map = {
        'PURCHASE': 'blue',
        'PROCUREMENT': 'green',
        'TRANSFER': 'purple',
        'TRANSFER_CANCEL': 'purple',
        'LOSS': 'red',
        'CHECK': 'orange',
        'SALES': 'green',
        'RETURN': 'cyan',
        'USER_RETURN': 'magenta',
        'SELL': 'green',
        'SECKILL': '#f50',
        'SECKILL_SELL': 'blue',
        'SECKILL_SELL_RETURN': 'blue',
        'CGRETURN': 'magenta'
      }
      return map[bizType] || 'default'
    }
  }
}
</script>

<style scoped>
.goods-info {
  display: flex;
  align-items: center;
  gap: 10px;
}

.goods-detail {
  flex: 1;
}

.goods-name {
  font-weight: 500;
  color: #333;
}

.goods-code {
  font-size: 12px;
  color: #999;
  margin-top: 2px;
}

.text-gray {
  font-size: 12px;
  color: #999;
}
</style>
